












































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
const cssPrefix = 'infoPopup';

@Component({
  components: {
    ...UUIFComponents,
    SwIcon,
  },
})

export default class InfoPopup extends SwExtendedVue {
  cssPrefix = cssPrefix;
  localClose : Boolean = true;
  @Prop({ type:Boolean })
  dropdownOpen : Boolean;
  @Prop()
  versionDataForFilesIndex : any;
  @Prop()
  fileListIndex : any;
  @Prop()
  popUpData : any;
  @Watch('dropdownOpen')
  dropDownOpenFunc() {
    console.warn('changes');
  }
  closePopup() {
    this.$emit('closePopup');
  }
}
